import { ICampaignRepository } from '../../domain/repositories/Campaign'

export const fetchCampaigns = (repo: ICampaignRepository) => async () => {
  const list = await repo.fetchAll()
  return list
}
